import React from 'react';
import merge from 'lodash/merge';
import { legend, mergeOptions, tooltip, xAxis, yAxis } from '../utils/commons';
import Chart from '../chart';
import stackedBorderRadius from '../utils/stacked_border_radius';
import mergeRefs from 'react-merge-refs';
var stackedBarOptions = _ref => {
  var {
    theme,
    chartRef,
    tickRef
  } = _ref;
  var selectedTick = tickRef;
  return {
    chart: {
      type: 'bar',
      // @ts-expect-error should be a list?
      spacing: 20,
      marginRight: 50
    },
    legend: legend({
      group: true,
      theme
    }),
    plotOptions: {
      bar: {
        borderWidth: 0,
        pointPadding: 0.2,
        pointWidth: 16,
        tooltip: {
          followPointer: true
        },
        // Sets and unsets the label color on hover
        point: {
          events: {
            mouseOver: e => {
              if (!chartRef.current) {
                return;
              }

              // @ts-expect-error category is there
              var {
                category
              } = e.target;
              var {
                ticks
              } = chartRef.current.chart.xAxis[0];
              var foundTick = Object.values(ticks).find(tick => {
                var _tick$label;
                // @ts-expect-error textStr is there
                return tick.pos > -1 && category === ((_tick$label = tick.label) === null || _tick$label === void 0 ? void 0 : _tick$label.textStr);
              });
              if (foundTick !== null && foundTick !== void 0 && foundTick.label) {
                selectedTick.current = foundTick;
                foundTick.label.css({
                  color: theme.palette.foreground.default
                });
              }
            },
            mouseOut: () => {
              if (!selectedTick.current) {
                return;
              }
              var {
                current: tick
              } = selectedTick;
              if (tick && tick.label) {
                tick.label.css({
                  color: theme.palette.foreground.light
                });
                selectedTick.current = null;
              }
            }
          }
        }
      },
      series: {
        stacking: 'normal'
      }
    },
    tooltip: merge(tooltip({
      theme,
      shared: true
    })),
    xAxis: xAxis({
      theme,
      shared: true
    }),
    yAxis: merge(yAxis({
      theme
    }), {
      reversedStacks: false
    })
  };
};
var StackedBar = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
    options,
    theme
  } = _ref2;
  var chartRef = React.useRef(null);
  var tickRef = React.useRef(null);
  var handleRef = mergeRefs([ref, chartRef]);
  var chartOptions = React.useMemo(() => {
    var mergedOptions = mergeOptions(stackedBarOptions({
      theme,
      chartRef,
      tickRef
    }), options);
    mergedOptions.chart.type = 'bar';
    var hasVerticalLegend = mergedOptions.legend && mergedOptions.legend.layout === 'vertical' && mergedOptions.legend.align === 'right';
    if (hasVerticalLegend) mergedOptions.chart.marginRight = undefined;
    if (mergedOptions.series.length > 0) {
      stackedBorderRadius(mergedOptions, theme);
    } else {
      mergedOptions.chart.marginRight = undefined;
    }
    return mergedOptions;
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(Chart, {
    immutable: true,
    options: chartOptions,
    ref: handleRef,
    theme: theme
  });
});
StackedBar.displayName = 'StackedBar';
export default StackedBar;